import BaseAccountController from '../../lib/controllers/BaseAccountController';

declare var LtFramework: lt.Static;

export default class AgreementHistoryController extends BaseAccountController {
	public static $inject: string[] = ['$scope', '$q', 'UserResource', 'MemberDetailsResource', 'AgreementHistoryResource', 'NonMemberAgreementHistoryResource'];

	public user: MyAccountApi.IUser;
	public memberDetails: MyAccountApi.IMemberDetails[];
	public agreementHistory: MyAccountApi.IAgreementHistory[];
	public memberId: number;
	public partyId: number;

	private readonly $q: ng.IQService;
	private readonly User: MyAccountApi.IUserResource;
	private readonly MemberDetails: MyAccountApi.IMemberDetailsResource;
	private readonly AgreementHistory: MyAccountApi.IAgreementHistoryResource;
	private readonly NonMemberAgreementHistory: MyAccountApi.INonMemberAgreementHistoryResource;

	constructor($scope: ng.IScope, $q: ng.IQService, User: MyAccountApi.IUserResource, MemberDetails: MyAccountApi.IMemberDetailsResource,
			AgreementHistory: MyAccountApi.IAgreementHistoryResource, NonMemberAgreementHistory: MyAccountApi.INonMemberAgreementHistoryResource) {
		super($scope);
		this.$q = $q;
		this.User = User;
		this.MemberDetails = MemberDetails;
		this.AgreementHistory = AgreementHistory;
		this.NonMemberAgreementHistory = NonMemberAgreementHistory;
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		// load My Account user details
		this.user = this.User.get();

		// load member details
		this.memberDetails = this.MemberDetails.query();

		this.$q.all([this.user.$promise, this.memberDetails.$promise]).then(() => {
			// check if user is a member
			if (this.user.memberContext && this.user.memberContext.memberId) {
				this.memberId = this.user.memberContext.memberId;
				this.agreementHistory = this.AgreementHistory.query({ memberId: this.memberId });
			} else {
				// non-member
				this.partyId = this.user.partyId;
				this.agreementHistory = this.NonMemberAgreementHistory.query({ partyId: this.partyId });
			}
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}
}
